// Module
var code = "<div class=\"dms-dashboard-wrapper dms-outer-element\" style=\"overflow-y: scroll\">\r\n    <div class=\"dms-grid-wrapper dms-dashboard #:data.GridName# grid-stack\"></div>\r\n</div>";
// Exports
export default code;